import { navigate, useLocation } from '@reach/router'
import { ReactNode } from 'react'
import { Modal } from 'react-responsive-modal'

type PopoutProps = {
    children?: ReactNode
    open: boolean
    onClose: () => void
}

const Popout: React.FC<PopoutProps> = ({ children, open, onClose, ...newProps }) => {
    const location = useLocation()

    const handleClose = () => {
        // eslint-disable-next-line no-console
        navigate(location.pathname).catch(console.log)
        onClose()
    }

    return <Modal {...newProps}
        open={open}
        onClose={handleClose}
        focusTrapped={false}
        closeOnOverlayClick={true}
        closeIcon={<i className='far fa-times-circle'></i>}
        classNames={{
            modalAnimationIn: 'popoutEnterModalAnimation',
            modalAnimationOut: 'popoutLeaveModalAnimation',
            modal: 'popoutModal',
            root: 'popoutModalRoot'
        }}
        animationDuration={500}>
        {children}
        <p className='forPrintOnly'>&copy; Copyright CareSource 2021. All rights reserved.</p>
    </Modal>
}

export default Popout
